export default __webpack_public_path__ + "static/media/join_community_teacher.d72d4949.png";